

const MarkdownComponents = {
  img: ({ src, alt, title, ...props }) => (
    <img style={{ minWidth: '20%', maxWidth: '100%', display: 'block', margin: '0 auto' }} src={src} alt={alt} title={title} {...props} />
  ),
  p: ({children, ...props}) => (
    <p className="blogPostContentP" {...props}>{children}</p>
  )

}

export default MarkdownComponents;